/* 
  Button Group Scroll Function - To Scroll Container Left or Right 
  -- scrollMode
    item: each click only scroll one item
    container: each click will scroll the distance of container 
*/
(() => {
  const scrollConfigs = [
    {
      container: '.compare-pair_table-wrap',
      btnGroup: '.compare-pair_button-group',
      btnLeft: '#compare-pair_scroll-left',
      btnRight: '#compare-pair_scroll-right',
      itemSelector: 'td',
      scrollMode: 'item' 
    },
    {
      container: '.ys-collection-by-type-scroll-wrapper',
      btnGroup: '.ys-product-list_button-group',
      btnLeft: '#ys-scroll-left',
      btnRight: '#ys-scroll-right',
      itemSelector: '.new-grid > *',
      scrollMode: 'container' 
    },
    {
      container: '.ys-bought-together-scrollable',
      btnGroup: '.ys-product-list_button-group',
      btnLeft: '#ys-scroll-left',
      btnRight: '#ys-scroll-right',
      itemSelector: '.ys-related-product-item',
      scrollMode: 'container' 
    },
    {
      container: '.ys-menu-list-wrapper',
      btnGroup: '.ys-menu-list-button-group.ys-product-list_button-group',
      btnLeft: '#ys-scroll-left',
      btnRight: '#ys-scroll-right',
      itemSelector: '.ys-menu-list-item',
      scrollMode: 'container' 
    }
  ];

  const initSingleScroll = (container, config, context) => {
    const btnGroup = context.querySelector(config.btnGroup);
    const btnLeft = context.querySelector(config.btnLeft);
    const btnRight = context.querySelector(config.btnRight);

    if (!btnLeft || !btnRight) return;

    let scrollTimeout = null;

    const updateButtons = () => {
      const currentScroll = container.scrollLeft;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const isScrollable = container.scrollWidth > container.clientWidth + 5;

      if (!isScrollable) {
        if (btnGroup) btnGroup.style.display = "none";
        return;
      }
      if (btnGroup) btnGroup.style.display = "flex";

      btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.3';
      btnLeft.style.cursor = currentScroll > 5 ? 'pointer' : 'default';

      btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.3';
      btnRight.style.cursor = currentScroll < maxScroll - 5 ? 'pointer' : 'default';
    };

    // 动态获取单个 item 的宽度（用于 item 模式）
    const getScrollStep = () => {
      const firstChild = container.querySelector(config.itemSelector);
      return firstChild ? firstChild.offsetWidth : 200;
    };

    // 获取所有子元素的绝对精确坐标（用于 container 模式）
    const getSnapPositions = () => {
      const items = container.querySelectorAll(config.itemSelector);
      const containerRect = container.getBoundingClientRect();
      return Array.from(items).map(item => {
        return item.getBoundingClientRect().left - containerRect.left + container.scrollLeft;
      });
    };

    // 兼容 Safari 的平滑滚动机制（用于 container 模式）
    const smoothScrollTo = (targetLeft) => {
      container.style.scrollSnapType = 'none';
      container.scrollTo({ left: targetLeft, behavior: 'smooth' });

      const handleScrollEnd = () => {
        container.style.scrollSnapType = '';
        container.removeEventListener('scrollend', handleScrollEnd);
      };

      if ('onscrollend' in window) {
        container.addEventListener('scrollend', handleScrollEnd);
      } else {
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScrollEnd, 400);
      }
    };

    // ================= 左翻页点击 =================
    btnLeft.onclick = () => {
      const currentScroll = container.scrollLeft;
      const isMobile = window.innerWidth <= 676;

      if (config.scrollMode === 'item') {
        const step = getScrollStep();
        if (isMobile && currentScroll < 100) {
          container.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          container.scrollBy({ left: -step, behavior: 'smooth' });
        }
      } else {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const idealTarget = currentScroll - container.clientWidth;
        let targetScroll = snapPositions.slice().reverse().find(pos => pos <= idealTarget + 10);
        if (targetScroll === undefined) targetScroll = snapPositions[0];

        if (targetScroll >= currentScroll - 5 && snapPositions.length > 1) {
          const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
          if (currentIndex > 0) targetScroll = snapPositions[currentIndex - 1];
        }
        smoothScrollTo(targetScroll);
      }
    };

    // ================= 右翻页点击 =================
    btnRight.onclick = () => {
      const currentScroll = container.scrollLeft;
      const isMobile = window.innerWidth <= 676;

      if (config.scrollMode === 'item') {
        const step = getScrollStep();
        if (isMobile && currentScroll < 5) {
          container.scrollTo({ left: 90, behavior: 'smooth' });
        } else {
          container.scrollBy({ left: step, behavior: 'smooth' });
        }
      } else {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const idealTarget = currentScroll + container.clientWidth;
        let targetScroll = snapPositions.find(pos => pos >= idealTarget - 10);
        if (targetScroll === undefined) targetScroll = snapPositions[snapPositions.length - 1];

        if (targetScroll <= currentScroll + 5 && snapPositions.length > 1) {
          const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
          if (currentIndex !== -1 && currentIndex < snapPositions.length - 1) {
            targetScroll = snapPositions[currentIndex + 1];
          }
        }
        smoothScrollTo(targetScroll);
      }
    };

    container.removeEventListener('scroll', updateButtons);
    container.addEventListener('scroll', updateButtons);

    setTimeout(updateButtons, 100);
  };

  const initAllScrollSections = (root = document) => {
    scrollConfigs.forEach(config => {
      const containers = root.querySelectorAll(config.container);
      containers.forEach(container => {
        const context = container.closest('.shopify-section') || container.parentElement || root;
        initSingleScroll(container, config, context);
      });
    });
  };

  // 全局缩放防抖/调整
  window.addEventListener('resize', () => {
    scrollConfigs.forEach(config => {
      document.querySelectorAll(config.container).forEach(container => {
        const maxScroll = container.scrollWidth - container.clientWidth;
        const btnGroup = container.closest('.shopify-section')?.querySelector(config.btnGroup);
        const btnLeft = container.closest('.shopify-section')?.querySelector(config.btnLeft);
        const btnRight = container.closest('.shopify-section')?.querySelector(config.btnRight);
        
        if (container && btnLeft && btnRight) {
          const isScrollable = container.scrollWidth > container.clientWidth + 5;
          if (btnGroup) btnGroup.style.display = isScrollable ? "flex" : "none";
          btnLeft.style.opacity = container.scrollLeft > 5 ? '1' : '0.3';
          btnRight.style.opacity = container.scrollLeft < maxScroll - 5 ? '1' : '0.3';
        }
      });
    });
  });

  if (document.readyState === 'complete') {
    initAllScrollSections(document);
  } else {
    window.addEventListener('load', () => initAllScrollSections(document));
  }

  document.addEventListener('shopify:section:load', (e) => {
    initAllScrollSections(e.target);
  });

  document.addEventListener("shopify:section:select", (e) => {
    initAllScrollSections(e.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    initAllScrollSections(document);
  });
})();